import { createListenerMiddleware } from '@reduxjs/toolkit';
import NodeServer from '../../common/node_server';
import { logout } from '../thunks/auth';

export const authListenerMiddleware = createListenerMiddleware();

authListenerMiddleware.startListening({
  actionCreator: logout.fulfilled,
  effect: () => {
    // Stop Socket.IO reconnect keep-alive after logout
    NodeServer.get().disconnect();
  },
});
